import type React from 'react';
import { useState } from 'react';
import { resolveImagePath } from '@/utils/imageResolver';

interface InquiryFormData {
  dateFrom: string;
  dateTo: string;
  name: string;
  email: string;
  phone: string;
  service: string;
  message: string;
}

export function About(): React.JSX.Element {
  const [formData, setFormData] = useState<InquiryFormData>({
    dateFrom: '',
    dateTo: '',
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  const serviceOptions = [
    'Select Service',
    'ONE WAY WATER TAXI SERVICE(EXUMA YACHT CLUB to STOCKING ISLAND)',
    'ROUNDTRIP WATER TAXI SERVICE(EXUMA YACHT CLUB to STOCKING ISLAND)',
    'ROUNDTRIP WATER TAXI SERVICE(AUGUSTA BAY BAHAMAS to STOCKING ISLAND)',
    'ROUNDTRIP WATER TAXI SERVICE(FEBRURY PINE to STOCKING ISLAND)',
    'HARBOUR TOURS(PLEASE CONTACT US TO BOOK AND CUSTOMIZED A TOUR FOR YOUR GROUP.)',
    'ONE WAY WATER TAXI SERVICE(EXUMA YACHT CLUB to STARFISH BEACH)',
    'ROUNDTRIP WATER TAXI SERVICE(Exuma Yacht Club to StarFish Beach and Chat \'N\' Chill™ Beach Bar & Grill)'
  ];

  return (
    <section className="relative py-16 bg-white overflow-hidden">
      {/* Background image overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url("${resolveImagePath('/images/hero-bg.jpg')}")`,
        }}
      />
      
      <div className="relative z-10 container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* About Us Section */}
          <div className="space-y-6">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-teal-600 mb-4">
                About Us
              </h2>
            </div>
            <p className="text-gray-700 leading-relaxed text-lg">
              Hi, I'm Captain Elvis Ferguson, owner of Elvis Water Taxi. I was born in and grew up in Exuma. 
              I have been the Harbour Master since 1999 and in 2006, I started this service to help Exuma 
              visitors who need to get to Chat 'N' Chill and other destinations on Stocking Island and around 
              Elizabeth Harbour.
            </p>
          </div>

          {/* Inquiry Form */}
          <div className="bg-white p-8 rounded-lg shadow-lg border">
            <h3 className="text-2xl font-bold text-teal-600 mb-6 text-center">
              INQUIRE NOW
            </h3>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Date Fields */}
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="text"
                  name="dateFrom"
                  placeholder="dd/mm/yy"
                  value={formData.dateFrom}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                />
                <input
                  type="text"
                  name="dateTo"
                  placeholder="dd/mm/yy"
                  value={formData.dateTo}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                />
              </div>

              {/* Name and Email */}
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  required
                />
              </div>

              {/* Phone */}
              <input
                type="tel"
                name="phone"
                placeholder="Mobile Number"
                value={formData.phone}
                onChange={handleInputChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                required
              />

              {/* Service Selection */}
              <select
                name="service"
                value={formData.service}
                onChange={handleInputChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                required
              >
                {serviceOptions.map((option, index) => (
                  <option 
                    key={index} 
                    value={index === 0 ? '' : option}
                    disabled={index === 0}
                  >
                    {option}
                  </option>
                ))}
              </select>

              {/* Message */}
              <textarea
                name="message"
                placeholder="Message"
                rows={4}
                value={formData.message}
                onChange={handleInputChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent resize-none"
              />

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-teal-600 text-white py-3 px-6 rounded-md hover:bg-teal-700 transition-colors duration-200 font-semibold text-lg"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}